import { render } from "./shareOnSocial.vue?vue&type=template&id=6f808621"
import script from "./shareOnSocial.vue?vue&type=script&lang=js"
export * from "./shareOnSocial.vue?vue&type=script&lang=js"

import "./shareOnSocial.vue?vue&type=style&index=0&id=6f808621&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__